(() => {
  if (window.ice62BriefReady) return;
  window.ice62BriefReady = true;
  const key = 'ice_phase62_sizing_brief';
  const contextKey = 'ice_phase62_tool_context';
  const kinds = new Set(['coffee', 'dish', 'ice']);
  const calculators = { coffee: 'coffee_machine_group_size_finder', dish: 'dishwasher_capacity_finder', ice: 'ice_machine_size_finder' };
  const config = document.querySelector('[data-ice62-brief-config]');
  if (!config) return;
  const words = JSON.parse(config.textContent);
  function clear() { try { sessionStorage.removeItem(key); sessionStorage.removeItem(contextKey); } catch (_) {} }
  function transfer(kind, text, wrapper) {
    if (!kinds.has(kind) || typeof text !== 'string' || !text.trim() || text.length > 18000) return;
    const url = new URL('/pages/contact-us', location.origin);
    url.searchParams.set('ice_tool_brief', kind);
    url.hash = 'IceNativeContactForm';
    let stored = false;
    try {
      const item = { version: 1, kind, text, expires: Date.now() + 30 * 60 * 1000 };
      sessionStorage.setItem(key, JSON.stringify(item));
      stored = JSON.parse(sessionStorage.getItem(key)).text === text;
    } catch (_) { clear(); }
    if (stored) {
      window.icePhase50Analytics?.track('hospitality_tool_brief_used', { calculator: calculators[kind] });
      location.assign(url.pathname + url.search + url.hash);
      return;
    }
    wrapper.querySelector('[data-ice62-fallback]')?.remove();
    const fallback = document.createElement('div'); fallback.dataset.ice62Fallback = '';
    const note = document.createElement('p'); note.textContent = words.fallback; note.setAttribute('role', 'status');
    const area = document.createElement('textarea'); area.readOnly = true; area.value = text; area.setAttribute('aria-label', words[kind]);
    const link = document.createElement('a'); link.href = '/pages/contact-us#IceNativeContactForm'; link.textContent = words.continue;
    fallback.append(note, area, link); wrapper.append(fallback); area.focus(); area.select();
  }
  function action(result, kind, getText) {
    if (!result || result.querySelector('[data-ice62-enquiry]')) return;
    const box = document.createElement('div'); box.className = 'ice62-brief-action'; box.dataset.ice62Enquiry = kind;
    const button = document.createElement('button'); button.type = 'button'; button.textContent = words.use;
    const note = document.createElement('p'); note.textContent = words.notice;
    button.addEventListener('click', () => transfer(kind, getText(), box));
    box.append(button, note); result.append(box);
  }
  function mount() {
    document.querySelectorAll('ice-capacity-finder[data-kind]').forEach(finder => {
      action(finder.querySelector('[data-ice50-result]'), finder.dataset.kind, () => finder.brief || '');
    });
    const iceForm = document.getElementById('ice-size-form');
    const iceResult = document.getElementById('ice-size-output');
    if (iceForm && iceResult && !iceForm.dataset.ice62BriefReady) {
      iceForm.dataset.ice62BriefReady = 'true';
      const text = () => {
        if (iceResult.classList.contains('hidden') || !iceForm.checkValidity()) return '';
        const lines = [words.ice, new Date().toLocaleDateString('en-AU', { timeZone: 'Australia/Sydney' })];
        iceForm.querySelectorAll('input[name], select[name]').forEach(input => {
          const label = input.closest('label')?.childNodes[0]?.textContent.trim() || input.name;
          lines.push(label + ': ' + (input.selectedOptions ? input.selectedOptions[0].textContent : input.value));
        });
        ['ice-size-capacity', 'ice-size-summary', 'ice-size-use', 'ice-size-format'].forEach(id => lines.push(document.getElementById(id)?.textContent || ''));
        lines.push('', words.planning);
        return lines.join('\n');
      };
      action(iceResult, 'ice', text);
      const invalidate = () => {
        iceResult.classList.add('hidden'); document.getElementById('ice-size-empty')?.classList.remove('hidden');
        iceResult.querySelector('[data-ice62-fallback]')?.remove();
      };
      iceForm.addEventListener('input', invalidate); iceForm.addEventListener('change', invalidate); iceForm.addEventListener('reset', invalidate);
    }
    const form = document.getElementById('IceNativeContactForm');
    const kind = new URLSearchParams(location.search).get('ice_tool_brief');
    if (!form || !kinds.has(kind) || form.dataset.ice62BriefReady) return;
    form.dataset.ice62BriefReady = 'true';
    const body = form.querySelector('[name="contact[body]"]'); if (!body) return;
    const panel = document.createElement('div'); panel.className = 'ice62-brief-review'; panel.setAttribute('role', 'status');
    const note = document.createElement('p'); panel.append(note);
    let item;
    try { item = JSON.parse(sessionStorage.getItem(key)); } catch (_) {}
    if (!item || item.version !== 1 || item.kind !== kind || (!Number.isFinite(item.expires) || item.expires <= Date.now()) || typeof item.text !== 'string' || item.text.length > 18000) {
      clear(); note.textContent = words.expired; body.closest('.ice-native-contact__field').before(panel); return;
    }
    note.textContent = words.review;
    const previousBody = body.value;
    if (!body.value.includes(item.text)) body.value = [body.value.trim(), item.text].filter(Boolean).join('\n\n');
    const sales = form.querySelector('input[value="Sales Enquiries"]');
    if (sales) { const recipient = document.getElementById('IceDepartmentEmail'); if (recipient) recipient.value = sales.dataset.recipient; sales.checked = true; sales.dispatchEvent(new Event('change', { bubbles: true })); }
    const field = document.createElement('input'); field.type = 'hidden'; field.name = 'contact[Sizing tool]'; field.value = words[kind]; form.append(field);
    const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = words.remove;
    remove.addEventListener('click', () => {
      if (body.value === [previousBody.trim(), item.text].filter(Boolean).join('\n\n')) body.value = previousBody;
      else body.value = body.value.replace(item.text, '').trim();
      field.remove(); panel.remove(); clear(); body.focus();
    });
    panel.append(remove); body.closest('.ice-native-contact__field').before(panel);
    try { sessionStorage.setItem(contextKey, JSON.stringify({ calculator: calculators[kind], expires: item.expires })); } catch (_) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
